import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';

import { AuthService } from '@services/auth.service';
import { UiService } from '@services/ui.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '@environments/environment';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  loginForm: UntypedFormGroup;
  isLoading: boolean;
  envName = environment.name;

  constructor(
    private authSrv: AuthService,
    private uiSrv: UiService,
    private fb: UntypedFormBuilder,
    private router: ActivatedRoute
  ) { }

  ngOnInit() {
    this.initForm();
    this.initSubscriptions();
  }

  onSubmit(): void {
    this.isLoading = true;
    this.authSrv.login(this.loginForm.value);
  }

  private initForm(): void {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  private initSubscriptions(): void {
    this.isLoading = false;

    this.subscription.add(
      this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
          this.isLoading = loadingState;
        })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
